import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

import { fetchImage } from '../../api/image';
import PageDataLoader from '../Utility/PageDataLoader';
import DeleteImageModal from './DeleteImageModal';
import { validatePermissionKey } from '../../helpers/permission';
import { DELETE_BATCH_IMAGE } from '../Utility/PermissionKeys';

const ThumbnailGallery = ({
  images,
  canDelete,
  batch,
  date,
  fetchNewData,
  authUser
}) => {
  const [deleteImageModal, setDeleteImageModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isGalleryZoom, setIsGalleryZoom] = useState(false);
  const [imagesLoading, setImageLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [loadMore, setLoadMore] = useState(false);

  const fetchUrls = async () => {
    setImageLoading(true);

    const processBatch = async (batch) => {
      const data = batch.map(async (i) => {
        const fileUrl = await fetchImage(i.documentKey);
        if (!fileUrl) return {};

        return {
          src: fileUrl,
          isVideo: i.is_video,
          altText: 'Batch media',
          caption: 'Batch media'
        };
      });

      return Promise.all(data);
    };

    const chunkSize = 2;
    const chunks = [];
    for (let i = 0; i < images.length; i += chunkSize) {
      chunks.push(images.slice(i, i + chunkSize));
    }

    let allItems = [];
    for (const chunk of chunks) {
      const resp = await processBatch(chunk);
      const filteredResp = resp.filter((value) => Object.keys(value).length !== 0);
      allItems = [...allItems, ...filteredResp];
      setItems([...allItems]);
      setImageLoading(false);
      setLoadMore(true);
    }
    setLoadMore(false);
  };

  function openDeleteImageModal() {
    setDeleteImageModal(true);
  }

  function closeDeleteImageModal() {
    setDeleteImageModal(false);
  }

  useEffect(() => {
    fetchUrls();
    // eslint-disable-next-line
  }, [images]);

  const ImagesLightbox = () => {
    const currentItem = items[photoIndex];
    if (!currentItem) return null;

    return (
      <>
        {isGalleryZoom && (
          currentItem.isVideo ? (
            <div
              className="lightbox-video-wrapper"
              onClick={() => setIsGalleryZoom(false)}
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                zIndex: 1000,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <video
                src={currentItem.src}
                controls
                autoPlay
                style={{ maxHeight: '80%', maxWidth: '90%' }}
              />
            </div>
          ) : (
            <Lightbox
              mainSrc={currentItem.src}
              nextSrc={items[(photoIndex + 1) % items.length]?.src}
              prevSrc={items[(photoIndex + items.length - 1) % items.length]?.src}
              onCloseRequest={() => setIsGalleryZoom(false)}
              onMovePrevRequest={() =>
                setPhotoIndex((photoIndex + items.length - 1) % items.length)
              }
              onMoveNextRequest={() =>
                setPhotoIndex((photoIndex + 1) % items.length)
              }
            />
          )
        )}
      </>
    );
  };

  const slides = items.map((item, index) => {
    return (
      <Col md="3" className="mb-2" key={index}>
        <div className="zoom-gallery thumbnail" style={{ position: 'relative' }}>
          {item.isVideo ? (
            <video
              src={item.src}
              controls
              onClick={() => {
                setIsGalleryZoom(true);
                setPhotoIndex(index);
              }}
              style={{ width: '100%', height: 'auto', cursor: 'pointer' }}
            />
          ) : (
            <img
              src={item.src}
              alt={item.altText}
              style={{ width: '100%', height: 'auto', cursor: 'pointer' }}
              onClick={() => {
                setIsGalleryZoom(true);
                setPhotoIndex(index);
              }}
            />
          )}

          {validatePermissionKey(authUser, DELETE_BATCH_IMAGE) && canDelete && (
            <Button
              size="sm"
              color="danger"
              className="mt-1 waves-effect waves-light deleteBtn"
              onClick={() => {
                setActiveIndex(index);
                openDeleteImageModal();
              }}
            >
              <i className="ri-delete-bin-6-line align-middle"></i>
            </Button>
          )}
        </div>
      </Col>
    );
  });

  return (
    <React.Fragment>
      {imagesLoading ? (
        <div className="text-center">
          <PageDataLoader />
        </div>
      ) : (
        <>
          <DeleteImageModal
            images={images}
            closeModalHandler={closeDeleteImageModal}
            modalOpenState={deleteImageModal}
            batch={batch}
            date={date}
            fetchNewData={fetchNewData}
            activeIndex={activeIndex}
          />
          <ImagesLightbox />
          <Row>{slides}</Row>
          {loadMore && (
            <div className="text-center">
              <PageDataLoader />
            </div>
          )}
        </>
      )}
    </React.Fragment>
  );
};

export default ThumbnailGallery;
